/* eslint-disable react/jsx-props-no-spreading */
import { Link, LinkProps } from 'react-router-dom';

import './TiledLink.css';
import './DarkTiledLink.css';
import './GreyTiledLink.css';

type TiledProps = { isNewTab?: boolean; ariaLabel: string };

export function TiledLink({
  to,
  className = '',
  id,
  children,
  isNewTab = false,
  ariaLabel,
  onClick,
  ...rest
}: LinkProps & TiledProps) {
  return (
    <Link
      to={to}
      className={className}
      id={id}
      target={isNewTab ? '_blank' : undefined}
      rel={isNewTab ? 'noopener noreferrer' : undefined}
      aria-label={ariaLabel}
      onClick={onClick}
      {...rest}
    >
      {children}
    </Link>
  );
}
